class StickyScroll extends HTMLElement {
  connectedCallback () {
    this.isMobile = window.matchMedia('(width <= 900px)')

    if (this.isMobile.matches === true) return

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.scrollDirection = ''
    this.scrollDirectionPrevious = ''

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.header = document.querySelector('[data-product-sticky-scroll-external-el="header"]')

    this.container = this.querySelector('[data-product-sticky-scroll-el="container"]')
    this.content = this.querySelector('[data-product-sticky-scroll-el="content"]')
    this.spacer = this.querySelector('[data-product-sticky-scroll-el="spacer"]')

    if (this.container === null || this.content === null || this.spacer === null) return

    this.updateEl()
    this.setupListeners()
    this.setupObservers()
  }

  setupListeners () {
    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll)
  }

  setupObservers () {
    this.onResizeObserved = this.onResizeObserved.bind(this)

    this.resizeObserver = new ResizeObserver(() => {
      this.onResizeObserved()
    })

    this.resizeObserver.observe(this.container)
    this.resizeObserver.observe(this.content)

    window.addEventListener('resize', this.onResizeObserved)
  }

  onResizeObserved () {
    this.requestTick()
  }

  getOffsetTop (el, parent = document.body, offsetTop = 0) {
    if (!isNaN(el.offsetTop)) {
      offsetTop += el.offsetTop
    }

    return el.offsetParent === parent
      ? offsetTop
      : this.getOffsetTop(el.offsetParent, parent, offsetTop)
  }

  onScroll () {
    const previouslyKnown = this.lastKnownY
    this.scrollDirectionPrevious = this.scrollDirection

    this.lastKnownY = window.scrollY
    this.scrollDirection = previouslyKnown < this.lastKnownY ? 'down' : 'up'

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setSticky()
  }

  setSticky () {
    const containerHeight = this.container.offsetHeight
    const contentHeight = this.content.offsetHeight
    const headerHeight = this.header.offsetHeight
    const headerTopSpacing = 30

    if (containerHeight > contentHeight && window.innerHeight < contentHeight) {
      this.content.classList.toggle('prd-ProductContent-sticky', false)

      const offsetAmount = window.innerHeight - contentHeight

      if (this.scrollDirectionPrevious !== this.scrollDirection) {
        const containerOffsetTop = this.getOffsetTop(this.container)
        const contentOffsetTop = this.getOffsetTop(this.content)

        this.spacer.style.setProperty('margin-top', `${contentOffsetTop - containerOffsetTop}px`)
      }

      if (this.scrollDirection === 'down') {
        this.content.style.setProperty('top', `${offsetAmount}px`)
        this.content.style.removeProperty('bottom')
      } else {
        this.content.style.setProperty('bottom', `${offsetAmount - headerHeight - headerTopSpacing}px`)
      }
    } else {
      this.content.classList.toggle('prd-ProductContent-sticky', true)
      this.content.style.removeProperty('top')
      this.content.style.removeProperty('bottom')
      this.spacer.style.removeProperty('margin-top')
    }
  }

  disconnectedCallback () {
    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('resize', this.onResizeObserved)

    if (this.resizeObserver) this.resizeObserver.disconnect()
  }
}

if (!customElements.get('sticky-scroll')) {
  customElements.define('sticky-scroll', StickyScroll)
}
